import { isArray } from "../checkType"

export const arrayLength = (array) => (isArray(array) ? array.length : 0)

export const arrayFirstElement = (array) => (isArray(array) ? array[0] : array)


export const convertToArray = (array) =>
  !array ? [] : isArray(array) ? array : [array]
